import { useState, useEffect } from "react";
import { useDismissAnnouncement } from "@/hooks/useTenantAnnouncements";
import { AnnouncementModal } from "./AnnouncementModal";
import type { PlatformAnnouncement } from "@/hooks/useTenantAnnouncements";

const SESSION_KEY = "login_announcements_shown";

interface LoginAnnouncementModalProps {
  announcements: PlatformAnnouncement[];
}

export const LoginAnnouncementModal = ({ announcements }: LoginAnnouncementModalProps) => {
  const dismiss = useDismissAnnouncement();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [shownThisSession, setShownThisSession] = useState<Set<string>>(new Set());

  useEffect(() => {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored) {
      try {
        setShownThisSession(new Set(JSON.parse(stored)));
      } catch {
        // ignore — corrupt sessionStorage value
      }
    }
  }, []);

  const unshown = announcements.filter((a) => !shownThisSession.has(a.id));

  if (unshown.length === 0 || currentIndex >= unshown.length) return null;

  const current = unshown[currentIndex];

  const handleDismissOrAck = (acknowledged: boolean) => {
    dismiss.mutate({ announcementId: current.id, acknowledged });

    // Mark as shown in session
    const updated = new Set(shownThisSession);
    updated.add(current.id);
    setShownThisSession(updated);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify([...updated]));

    setCurrentIndex((prev) => prev + 1);
  };

  return (
    <AnnouncementModal
      announcement={current}
      onDismiss={() => handleDismissOrAck(false)}
      onAcknowledge={() => handleDismissOrAck(true)}
    />
  );
};
